// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card {
  margin: 30px;
  padding: 30px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1254901961);
  display: flex;
  flex-direction: column;
  max-width: 360px;
}

.d-row {
  display: flex;
  flex-direction: row;
}

.d-col {
  display: flex;
  flex-direction: column;
}

.justify-content-center {
  justify-content: center;
}

.justify-content-end {
  justify-content: flex-end;
}

.align-items-center {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.align-items-center img {
  background-color: #206ead;
  padding: 1em;
  width: 80%;
}

.bottom-btn {
  padding: 25px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/account/components/forgot-password/forgot-password.component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,aAAA;EACA,iDAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,aAAA;EACA,mBAAA;AACJ;;AAEA;EACI,aAAA;EACA,sBAAA;AACJ;;AAEA;EACI,uBAAA;AACJ;;AAEA;EACI,yBAAA;AACJ;;AAEA;EACI,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACJ;AACI;EACI,yBAAA;EACA,YAAA;EACA,UAAA;AACR;;AAGA;EACI,aAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAAJ","sourcesContent":[".card {\n    margin: 30px;\n    padding: 30px;\n    box-shadow: 0 3px 6px #00000020;\n    display: flex;\n    flex-direction: column;\n    max-width: 360px;\n}\n\n.d-row {\n    display: flex;\n    flex-direction: row;\n}\n\n.d-col {\n    display: flex;\n    flex-direction: column;\n}\n\n.justify-content-center {\n    justify-content: center;\n}\n\n.justify-content-end {\n    justify-content: flex-end;\n}\n\n.align-items-center {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    img{\n        background-color: #206ead;\n        padding: 1em;\n        width: 80%;\n    }\n}\n\n.bottom-btn {\n    padding: 25px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
